require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-meet-keri-marketer-turned-front-end-developer.json") })
        }
      }, "path---blog-meet-keri-marketer-turned-front-end-developer");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-meet-keri-marketer-turned-front-end-developer!./.cache/json/blog-meet-keri-marketer-turned-front-end-developer.json
// module id = 966
// module chunks = 231608221292675